@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';

$border-thickness: 0.15rem;

.dropdowncontainer {
  display: inline-block;
  position: relative;

  /* Button*/
  .button {
    svg {
      fill: _palette(bg-secondary);
    }

    &.button:focus {
      svg {
        fill: _palette(secondary);
      }
    }
  }

  .openButton {
    background-color: _palette(bg-secondary) !important;
    color: _palette(secondary) !important;
    border: $border-thickness solid _palette(secondary) !important;
    box-shadow:
      0 0 4px 0 rgba(15, 106, 136, 0.12),
      0 8px 8px 0 rgba(15, 106, 136, 0.24);
    outline: none;

    svg {
      fill: _palette(secondary);
    }
  }
}

$dropdownmenu-font-size: 14;

.dropdownmenu {
  background-color: _palette(bg-secondary);
  border: $border-thickness solid _palette(secondary);
  border-radius: 4px;
  box-shadow: 0 15px 15px 2px rgb(0 0 0 / 0.4);
  margin-top: 0.35em;
  position: absolute;
  right: 0;
  min-width: fit-content;
  font-size: #{$dropdownmenu-font-size}px;
  box-sizing: border-box;
  z-index: 10;

  .dropdownitem {
    @include barlowMedium($dropdownmenu-font-size);
    color: _palette(text-primary);
    height: 2.5em;
    padding: 0 0.75em;
    display: flex;
    align-items: center;
    white-space: nowrap;

    &.borderTop {
      border-top: 0.2em solid _palette(icon-weak-contour);
    }

    svg {
      fill: _palette(icon-weak-contour);
      margin-right: 0.5em;
    }

    &:hover {
      background-color: rgba(15, 106, 136, 0.1);
      cursor: pointer;
    }

    &:focus {
      background-color: #80c0d5;
      outline: none;
    }

    &:hover,
    &:focus,
    &:hover:focus {
      svg {
        fill: _palette(secondary);
      }
    }

    &.disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }
}
